<template>
    <slot
        :days="days"
        :popup="popup"
        :set-ref="setRef"
        :setup-popup-day="setupPopupDay"
    ></slot>
</template>

<script>
import { format } from 'date-fns';
import { ref, defineComponent, onMounted, nextTick } from 'vue';

import { getPerformances } from '../services/inventory';
import { initialiseScroller } from '../modules/scroller';

export default defineComponent({
    name: 'HomeCalendar',

    setup() {
        const popup = ref({
            title: null,
            items: [],
        });
        const days = ref([]);
        const refs = {};

        const setRef = (ref, el) => {
            refs[ref] = el;
        }

        onMounted(() => {
            loadData()
                .finally(async () => {
                    await nextTick();
                    initialiseScroller(refs.scroller, {
                        slidesPerGroup: 15,
                    });
                });
        });

        const loadData = async () => {
            // 90 days in future
            const calendarEnd = new Date((new Date()).getTime() + (1000 * 60 * 60 * 24 * 90));
            calendarEnd.setHours(0);
            calendarEnd.setMinutes(0);
            calendarEnd.setSeconds(0);

            return getPerformances()
                .then(perfs => {
                    let date = new Date();
                    date.setHours(0);
                    date.setMinutes(0);
                    date.setSeconds(0);

                    while (date <= calendarEnd) {
                        let monthTitle = '';
                        if (days.value.length === 0 || date.getDate() === 1) {
                            monthTitle = format(date, 'MMMM');
                        }

                        const endOfDay = new Date(date);
                        endOfDay.setDate(date.getDate() + 1);

                        days.value.push({
                            month_title: monthTitle,
                            day: format(date, 'iii'),
                            date: format(date, 'd'),
                            dateObject: date,
                            is_today: days.value.length === 0,
                            performances: perfs.filter(p => p.performancedate > date && p.performancedate < endOfDay),
                        });

                        date = new Date(endOfDay.getTime());
                    }
                });
        };

        const setupPopupDay = (day) => {
            popup.value.title = format(day.dateObject, 'EEE MMMM d');
            popup.value.items = day.performances;
            const dialog = document.querySelector('#calendar-popup');
            dialog.showModal();
            let popupScroller;

            dialog.querySelectorAll('[data-dialog-close]').forEach(el => {
                el.addEventListener('click', () => {
                    dialog.close();
                    popupScroller.destroy();
                }, false);
            });

            setTimeout(() => {
                popupScroller = initialiseScroller(dialog);
            }, 50);
        };

        return {
            days,
            popup,
            setupPopupDay,
            setRef,
        };
    },
});
</script>
